import { collection, doc, addDoc, setDoc, getDoc, getDocs, updateDoc, deleteDoc, getFirestore, query, where, orderBy } from "firebase/firestore";
import moment from "moment";

import fbApp from "./app";

const db = getFirestore(fbApp);

let encodedAuth = localStorage.getItem("auth");
let uid;
let email;
let role;
if (encodedAuth != null) {
    let decodedAuth = atob(encodedAuth);
    let split = decodedAuth.split("-");
    uid = split[0];
    email = split[1];
    role = split[2];
}

// Paths
const studentPath = "studentData";
const mentorPath = "mentorData";
const schoolPath = "schoolData";
const apartmentPath = "apartmentData";
const teamPath = "teamData";
const activityPath = "taData";
const generatedActivityPath = "generatedTAData";
const competitionPath = "competitionData";
const coursesPath = "coursesData";
const tagsPath = "tagData";
const taskPath = "tasksData";
const projectsPath = "projectsData";
const partnerPath = "partnerData";
const sessionPath = "sessionData";
const subjectPath="subject";

// Functions

async function deleteGeneratedActivity(docId) {
    const docRef = doc(db, generatedActivityPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", generatedActivityPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function addStudent(fname, lname, school, gender, classVal, section, aspiration, isTeamLeader, comments,/* currentActivity,*/ email, tags, guardians) {
    try {
        const docRef = collection(db, studentPath);
        const studentSnap = await addDoc(docRef, {
            name: {
                firstName: fname,
                lastName: lname
            },
            school: school,
            gender: gender,
            class: classVal,
            section: section,
            // whatsappNumber: whatsappNo,
            aspiration: aspiration,
            // currentExperiment: currentExperiment,
            isTeamLeader: isTeamLeader,
            comments:comments,/*sucharitha 4.8*/
            email: email,
            tags: tags,
            guardians: guardians
        });

        const docRef2 = doc(db, `/${studentPath}/${studentSnap.id}/tinkeringActivities`, "base_version");

        const docRef3 = doc(db, "tinkeringActivityData",/* currentActivity*/);
        const docSnap = await getDoc(docRef3);

        await setDoc(docRef2, docSnap.data());
    } catch (err) {
        console.error(err);
    }
}

async function getStudents() {
    const docRef = collection(db, studentPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getStudent(studentId) {
    const docRef = doc(db, studentPath, studentId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}


// async function updateStudent(id, fname, lname, school, gender, classVal, section, email, whatsappNo, aspiration, currentExperiment, isTeamLeader) {
async function updateStudent(id, fname, lname, school, gender, classVal, section,  aspiration, isTeamLeader, comments, email, tags, guardians) {
    const docRef = doc(db, studentPath, id);
    await updateDoc(docRef, {
        name: {
            firstName: fname,
            lastName: lname
        },
        school: school,
        gender: gender,
        class: classVal,
        section: section,
        // whatsappNumber: whatsappNo,
        aspiration: aspiration,
        // currentExperiment: currentExperiment,
        isTeamLeader: isTeamLeader,
        comments: comments,
        email: email,
        tags: tags,
        guardians: guardians
    });
}

async function deleteStudent(docId) {
    const docRef = doc(db, studentPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", studentPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryStudent(field, comparision, value) {
    const ref = collection(db, studentPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

// async function addMentor(college, fName, lName, study, department, year, email, whatsappNo, aspiration, experiment, competitionMapped) {
async function addMentor(fName, lName, skillSet) {
    const docRef = collection(db, mentorPath);
    await addDoc(docRef, {
        // aspiration: aspiration,
        // college: college,
        // competitionMapped: competitionMapped,
        // department: department,
        // email: email,
        // currentExperiment: experiment,
        // year: year,
        name: {
            firstName: fName,
            lastName: lName
        },
        // study: study,
        // whatsappNumber: whatsappNo
        skillSet: skillSet
    });
}

async function getMentors() {
    const docRef = collection(db, mentorPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getMentor(mentorId) {
    const docRef = doc(db, mentorPath, mentorId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

// async function updateMentor(docId, college, fName, lName, study, department, year, email, whatsappNo, aspiration, experiment, competitionMapped) {
async function updateMentor(docId, fName, lName, skillSet) {
    const docRef = doc(db, mentorPath, docId);
    await updateDoc(docRef, {
        // aspiration: aspiration,
        // college: college,
        // competitionMapped: competitionMapped,
        // department: department,
        // email: email,
        // currentExperiment: experiment,
        // year: year,
        name: {
            firstName: fName,
            lastName: lName
        },
        skillSet: skillSet
        // study: study,
        // whatsappNumber: whatsappNo
    });
}

async function deleteMentor(docId) {
    const docRef = doc(db, mentorPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", mentorPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryMentor(field, comparision, value) {
    const ref = collection(db, mentorPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addSchool(name,isATL,address,city,state,pincode,inchargeFName,inchargeLName,inchargeEmail,inchargeWhatsappNumber,principalFName,principalLName,principalEmail,principalWhatsappNumber,correspondentfName,correspondentlName,correspondentEmail,correspondentWhatsappNumber,sameAsPrincipal,syllabus,webSite,paidSubscription,socialMediaLink) {
    const docRef = collection(db, schoolPath);
    await addDoc(docRef, {
        name: name,
        isATL: isATL,
        address: {
            addressLine1: address,
            city: city,
            state: state,
            pincode: pincode,
            country: "India"
        },
        atlIncharge: {
            firstName:inchargeFName,
            lastName:inchargeLName,
            email: inchargeEmail,
            whatsappNumber:inchargeWhatsappNumber,
        },
        principal: {
            firstName:principalFName,
            lastName:principalLName,
            email:principalEmail,
            whatsappNumber:principalWhatsappNumber,
        },
        correspondent: {
            firstName:correspondentfName,
            lastName:correspondentlName,
            email:correspondentEmail,
            whatsappNumber:correspondentWhatsappNumber,
        },
        date: moment().format(),
        sameAsPrincipal:sameAsPrincipal,
        syllabus: syllabus,
        webSite: webSite,
        paidSubscription:paidSubscription,
        socialMediaLink:socialMediaLink,
    });
}

async function getSchools() {
    const docRef = query(collection(db, schoolPath), orderBy("name"));
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getSchool(schoolId) {
    const docRef = doc(db, schoolPath, schoolId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateSchool(schoolId,name,isATL,address,city,state,pincode,inchargeFName,inchargeLName,inchargeEmail,inchargeWhatsappNumber,principalFName,principalLName,principalEmail,principalWhatsappNumber,correspondentfName,correspondentlName,correspondentEmail,correspondentWhatsappNumber,sameAsPrincipal,syllabus,webSite,paidSubscription,socialMediaLink,) {
    const docRef = doc(db, schoolPath, schoolId);
    await updateDoc(docRef, {
        name: name,
        isATL: isATL,
        address: {
            addressLine1: address,
            city: city,
            state: state,
            pincode: pincode,
            country: "India"
        },
        atlIncharge: {
            firstName:inchargeFName,
            lastName:inchargeLName,
            email: inchargeEmail,
            whatsappNumber:inchargeWhatsappNumber,
        },
        principal: {
            firstName:principalFName,
            lastName:principalLName,
            email:principalEmail,
            whatsappNumber:principalWhatsappNumber,
        },
        correspondent: {
            firstName:correspondentfName,
            lastName:correspondentlName,
            email:correspondentEmail,
            whatsappNumber:correspondentWhatsappNumber,
        },
        date: moment().format(),
        sameAsPrincipal:sameAsPrincipal,
        syllabus: syllabus,
        webSite: webSite,
        paidSubscription:paidSubscription,
        socialMediaLink:socialMediaLink,
    });
}

async function deleteSchool(docId) {
    console.log(docId);
    const docRef = doc(db, schoolPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", schoolPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function querySchool(field, comparision, value) {
    const ref = collection(db, schoolPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addApartment(name,address,city,state,pincode,inchargeFName,inchargeLName,inchargeEmail,inchargeWhatsappNumber) {
    const docRef = collection(db, apartmentPath);
    await addDoc(docRef, {
        name: name,
        address: {
            addressLine1: address,
            city: city,
            state: state,
            pincode: pincode,
            country: "India"
        },
        incharge: {
            firstName:inchargeFName,
            lastName:inchargeLName,
            email: inchargeEmail,
            whatsappNumber:inchargeWhatsappNumber,
        },
        date: moment().format()
    });
}

async function getApartments() {
    const docRef = collection(db, apartmentPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getApartment(apartmentId) {
    const docRef = doc(db, apartmentPath, apartmentId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateApartment(apartmentId, name,address,city,state,pincode,inchargeFName,inchargeLName,inchargeEmail,inchargeWhatsappNumber) {
    const docRef = doc(db, apartmentPath, apartmentId);
    await updateDoc(docRef, {
        name: name,
        address: {
            addressLine1: address,
            city: city,
            state: state,
            pincode: pincode,
            country: "India"
        },
        incharge: {
            firstName:inchargeFName,
            lastName:inchargeLName,
            email: inchargeEmail,
            whatsappNumber:inchargeWhatsappNumber,
        },
        date: moment().format()
    });
}

async function deleteApartment(docId) {
    console.log(docId);
    const docRef = doc(db, schoolPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", apartmentPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryApartment(field, comparision, value) {
    const ref = collection(db, apartmentPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addTeam(teamName, teamLeader, teamMembers, schoolVal) {
    console.log(teamName, teamLeader, teamMembers);
    const docRef = collection(db, teamPath);
    const teamLeaderRef = doc(db, "studentData", teamLeader);
    const membersRefs = [];
    teamMembers.forEach(member => {
        membersRefs.push(doc(db, "studentData", member));
    });
    await addDoc(docRef, {
        name: teamName,
        leader: teamLeaderRef,
        members: membersRefs,
        schoolVal: schoolVal,
    })
}


async function getTeams() {
    const docRef = collection(db, teamPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getTeam(schoolId) {
    const docRef = doc(db, teamPath, schoolId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateTeam(teamName, teamLeader, teamMembers, docId) {
    const docRef = doc(db, teamPath, docId);
    const teamLeaderRef = doc(db, "studentData", teamLeader);
    const membersRefs = [];
    teamMembers.forEach(member => {
        membersRefs.push(doc(db, "studentData", member));
    });
    await updateDoc(docRef, {
        name: teamName,
        leader: teamLeaderRef,
        members: membersRefs,
    });
}

async function deleteTeam(docId) {
    const docRef = doc(db, teamPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", teamPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryTeam(field, comparision, value) {
    const ref = collection(db, teamPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addActivity(taID, taName, subject, topic, subTopic, intro, goals, materials, instructions, tips, assessment, extensions, resources) {
    const docRef = doc(db, activityPath, taID);

    // Store a reference to the user who created this activity ONLY if their role is 'creator'
    // This prevents adding extra fields for non-creator roles
    const createdByRef = (uid && role === "creator") ? doc(db, "atlUsers", uid) : undefined;

    const data = {
        taID: taID,
        taName: taName,
        subject: subject,
        topic: topic,
        subTopic: subTopic,
        intro: intro,
        goals: goals,
        materials: materials,
        instructions: instructions,
        tips: tips,
        assessment: assessment,
        extensions: extensions,
        resources: resources,
    };

    if (createdByRef !== undefined) {
        data.createdByRef = createdByRef;
        data.createdByUID = uid;
    }

    await setDoc(docRef, data);
}

async function getActivities() {
    const docRef = collection(db, activityPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getActivity(activityId) {
    const docRef = doc(db, activityPath, activityId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateActivity(docId, taID, taName, subject, topic, subTopic, intro, goals, materials, instructions, tips, assessment, extensions, resources, docRef = doc(db, activityPath, docId)) {
    await updateDoc(docRef, {
        taID: taID,
        taName: taName,
        subject: subject,
        topic: topic,
        subTopic: subTopic,
        intro: intro,
        goals: goals,
        materials: materials,
        instructions: instructions,
        tips: tips,
        assessment: assessment,
        extensions: extensions,
        resources: resources
    });
}
async function updateTActivity(taID, taName, intro, goals, materials, instructions, tips, assessment, extensions, resources, comment, uploadURL, docRef) {
    const data = {
        taID: taID,
        taName: taName,
        intro: intro,
        goals: goals,
        materials: materials,
        instructions: instructions,
        tips: tips,
        assessment: assessment,
        extensions: extensions,
        resources: resources,
        comment: comment === undefined ? "" : comment,
        files: uploadURL.length > 0 ? uploadURL : []
    }

    console.log(data);

    await updateDoc(docRef, data);
}

async function deleteActivity(docId) {
    const docRef = doc(db, activityPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", activityPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryActivity(field, comparision, value) {
    const ref = collection(db, activityPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addCompetition(competName, description, organizedBy, applStartDate, applEndDate, classesFrom, classesTo,
                              atlSchools, nonAtlSchools, individual, team, refLink, requirements, feeDetails, compStartDate, compEndDate, fileURL = "") {
    const docRef = collection(db, competitionPath);
    const data = {
        name: competName,
        description: description,
        organizedBy: organizedBy,
        applicationStartDate: applStartDate,
        applicationEndDate: applEndDate,
        eligibility: {
            classesFrom: classesFrom,
            classesTo: classesTo,
            atlSchools: atlSchools,
            nonAtlSchools: nonAtlSchools,
            individual: individual,
            team: team,
        },
        refLink: refLink,
        requirements: requirements,
        paymentDetails: feeDetails,
        competitionStartDate: compStartDate,
        competitionEndDate: compEndDate
    };

    if(fileURL !== "") {
        data.fileURL = fileURL;
    }

    await addDoc(docRef, data);
}

async function getCompetitions() {
    const docRef = collection(db, competitionPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getCompetition(competitionId) {
    const docRef = doc(db, competitionPath, competitionId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateCompetition(competitionId, competName, description, organizedBy, applStartDate, applEndDate, classesFrom, classesTo,
                              atlSchools, nonAtlSchools, individual, team, refLink, requirements, feeDetails, compStartDate, compEndDate, fileURL = "") {
    const docRef = doc(db, competitionPath, competitionId);
    const data = {
        name: competName,
        description: description,
        organizedBy: organizedBy,
        applicationStartDate: applStartDate,
        applicationEndDate: applEndDate,
        eligibility: {
            classesFrom: classesFrom,
            classesTo: classesTo,
            atlSchools: atlSchools,
            nonAtlSchools: nonAtlSchools,
            individual: individual,
            team: team,
        },
        refLink: refLink,
        requirements: requirements,
        paymentDetails: feeDetails,
        competitionStartDate: compStartDate,
        competitionEndDate: compEndDate
    };

    if(fileURL !== "") {
        data.fileURL = fileURL;
    }

    await setDoc(docRef, data, {merge: true});
}

async function updateStudentCompetition(competName, description, organizedBy, applStartDate, applEndDate, classesFrom, classesTo,
                                     atlSchools, nonAtlSchools, individual, team, refLink, requirements, feeDetails, compStartDate, compEndDate, fileURL, comments, studentSubmission, docRef) {
    const data = {
    name: competName,
    description: description,
    
    organizedBy: organizedBy,
    applicationStartDate: applStartDate,
    applicationEndDate: applEndDate,
    eligibility: {
      classesFrom: classesFrom,
      classesTo: classesTo,
      atlSchools: atlSchools,
      nonAtlSchools: nonAtlSchools,
      individual: individual,
      team: team,
    },
    refLink: refLink,
    requirements: requirements,
    paymentDetails: feeDetails,
    competitionStartDate: compStartDate,
    competitionEndDate: compEndDate,
    comments: comments === undefined ? "" : comments,
   }
 
   if(fileURL !== "") {
        data.uploadFile = fileURL;
    }
  if (studentSubmission !== "") {
      data.studentUploadFile = studentSubmission;
  }
    await updateDoc(docRef, data);
}

async function deleteCompetition(docId) {
    const docRef = doc(db, competitionPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", competitionPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryCompetition(field, comparision, value) {
    const ref = collection(db, competitionPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function task(taskName, taskDescription, taskDueDate, taskDone, taskComments) {
    try {
        const docRef = collection(db, taskPath);

        const users = [
            doc(db, "atlUsers", uid),
        ];

        const docSnap = await addDoc(docRef, {
            taskName: taskName,
            taskDescription: taskDescription,
            taskDueDate: taskDueDate,
            taskDone: taskDone,
            taskComments: taskComments,
            users: users
        });

        for (const user of users) {
            const userDocRef = user;
            const docData = await getDoc(userDocRef);
            if (docData.data().tasks === undefined) {
                await setDoc(userDocRef, {
                    tasks: [{taskName: taskName, taskDueDate: taskDueDate, ref: doc(db, "tasksData", docSnap.id)}]
                }, {merge: true});
            } else {
                await setDoc(userDocRef, {
                    tasks: [...docData.data().tasks, {
                        taskName: taskName,
                        taskDueDate: taskDueDate,
                        ref: doc(db, "tasksData", docSnap.id)
                    }]
                }, {merge: true});
            }
        }

    } catch(err) {
        console.error(err);
    }
}

async function taskAssign(taskId, user) {
    try {
        const userDocRef = doc(db, "atlUsers", user);

        const userData = await getDoc(userDocRef);

        let tasks = [];

        if(userData.data().tasks !== undefined) {
            userData.data().tasks.forEach(task => {
                tasks.push(task);
            });
        }

        const taskRef = doc(db, taskPath, taskId);
        const taskData = await getDoc(taskRef);
        const users = [...taskData.data().users];
        users.push(userDocRef);
        tasks.push({
            ref: taskRef,
            taskName: taskData.data().taskName
        });

        await setDoc(userDocRef, {
            tasks: tasks
        }, {merge: true});

        await setDoc(taskRef, {
            assignedTo: userDocRef,
            users: users
        }, {merge: true});
    } catch(err) {
        console.error(err);
    }
}

async function deleteTask(docId) {
    const docRef = doc(db, taskPath, docId);
    const taskData = await getDoc(docRef);
    if (taskData.data().assignedTo !== undefined && role === "student") {
        return "cannot-delete: Permission Denied";
    }

    // Delete the task document
    await deleteDoc(docRef);


    const users = taskData.data().users;
    for (const userRef of users) {
        const userDoc = await getDoc(userRef);
        let tasks = userDoc.data().tasks;

        // Remove the task reference from the user's tasks array
        tasks = tasks.filter(task => task.ref.id !== docId);

        // Update the user's document with the modified tasks array
        await setDoc(userRef, { tasks: tasks }, { merge: true });
    }
}

async function getTasksById(documentRef) {
    const documentData = await getDoc(documentRef);
    return documentData;
}

async function addCourse(courseName, courseTag, description, organizedBy, applStartDate, applEndDate, crsStartDate, crsEndDate, classesFrom, classesTo, refLink, requirements, courseTAs = []) {
    const docRef = collection(db, coursesPath);
    await addDoc(docRef, {
        courseName: courseName,
        courseTag: courseTag,
        description: description,
        organizedBy: organizedBy,
        applicationStartDate: applStartDate,
        applicationEndDate: applEndDate,
        crsStartDate: crsStartDate,
        crsEndDate: crsEndDate,
        classesFrom: classesFrom,
        classesTo: classesTo,
        refLink: refLink,
        requirements: requirements,
        courseTAs: courseTAs,
    });
}

async function getCourses() {
    const docRef = collection(db, coursesPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}


async function getCourse(coursesId) {
    const docRef = doc(db, coursesPath, coursesId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateCourse(id, courseName, courseTag, description, organizedBy, applStartDate, applEndDate, crsStartDate, crsEndDate, classesFrom, classesTo, refLink, requirements, courseTAs = []) {
    const docRef = doc(db, coursesPath, id);
    await updateDoc(docRef, {
        courseName: courseName,
        courseTag: courseTag,
        description: description,
        organizedBy: organizedBy,
        applicationStartDate: applStartDate,
        applicationEndDate: applEndDate,
        crsStartDate: crsStartDate,
        crsEndDate: crsEndDate,
        classesFrom: classesFrom,
        classesTo: classesTo,
        refLink: refLink,
        requirements: requirements,
        courseTAs: courseTAs,
    });
}

async function updateStudentCourse(courseName, courseTag, description, organizedBy, applStartDate, applEndDate, crsStartDate, crsEndDate, classesFrom, classesTo, refLink, requirements, comments, fileURL, docRef) {
        const data = {
        courseName: courseName,
        courseTag: courseTag,
        description: description,
        organizedBy: organizedBy,
        applicationStartDate: applStartDate,
        applicationEndDate: applEndDate,
        crsStartDate: crsStartDate,
        crsEndDate: crsEndDate,
        classesFrom: classesFrom,
        classesTo: classesTo,
        refLink: refLink,
        requirements: requirements,
        comments: comments === undefined ? "" : comments
        }
        if(fileURL !== "") {
            data.courseUploadFile = fileURL;
        }
        await updateDoc(docRef,data);
    }


async function deleteCourse(docId) {
    const docRef = doc(db, coursesPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", coursesPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryCourse(field, comparision, value) {
    const ref = collection(db, coursesPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addProject(projectId, projectName, projectDescription, projectStartDate, projectEndDate, tags, projectMembers, tasks, schoolName = "all") {
    const ref = doc(db, projectsPath, projectId);
    await setDoc(ref, {
        projectId: projectId,
        projectName: projectName,
        projectDescription: projectDescription,
        expectedStartDate: projectStartDate,
        expectedEndDate: projectEndDate,
        projectMembers: projectMembers,
        tags: tags,
        tasks: tasks,
        schoolName: schoolName
    });
}

async function getProjects() {
    const ref = collection(db, projectsPath);
    const docSnaps = await getDocs(ref);
    return docSnaps;
}

async function getProject(projectId) {
    const ref = doc(db, projectsPath, projectId);
    const docSnap = await getDoc(ref);
    return docSnap;
}

async function updateProject(projectId, projectName, projectDescription, projectStartDate, projectEndDate, tags, projectMembers, tasks) {
    const ref = doc(db, projectsPath, projectId);
    await setDoc(ref, {
        projectId: projectId,
        projectName: projectName,
        projectDescription: projectDescription,
        expectedStartDate: projectStartDate,
        expectedEndDate: projectEndDate,
        projectMembers: projectMembers,
        tags: tags,
        tasks: tasks
    }, {merge: true});
}

async function deleteProject(docId) {
    const docRef = doc(db, projectsPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", projectsPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryProject(field, comparision, value) {
    const ref = collection(db, projectsPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function addPartner(type, name, line1, city, state, country, pincode, dmFirstName, dmLastName, dmEmail, dmPhone,
                          contactPersons, proposedActivities, projects, mouURL = "") {
    const docRef = collection(db, partnerPath);

    const data = {
        type: type,
        name: name,
        address: {
            addressLine1: line1,
            city: city,
            state: state,
            country: country,
            pincode: pincode
        },
        decisionMaker: {
            firstName: dmFirstName,
            lastName: dmLastName,
            email: dmEmail,
            phone: dmPhone
        },
        contactPersons: contactPersons,
        proposedActivities: proposedActivities,
        projects: projects,
    }

    if(mouURL !== ""){
        data.mouFile = mouURL;
    }

    await addDoc(docRef, data);
}

async function getPartners() {
    const docRef = collection(db, partnerPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getPartner(partnerId) {
    const docRef = doc(db, partnerPath, partnerId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updatePartner(partnerId, type, name, line1, city, state, country, pincode, dmFirstName, dmLastName, dmEmail, dmPhone,
                             contactPersons, proposedActivities, projects, mouURL = "") {
    const docRef = doc(db, partnerPath, partnerId);

    const data = {
        type: type,
        name: name,
        address: {
            addressLine1: line1,
            city: city,
            state: state,
            country: country,
            pincode: pincode
        },
        decisionMaker: {
            firstName: dmFirstName,
            lastName: dmLastName,
            email: dmEmail,
            phone: dmPhone
        },
        contactPersons: contactPersons,
        projects: projects,
        proposedActivities: proposedActivities,
    }

    if(mouURL !== ""){
        data.mouFile = mouURL;
    }

    await setDoc(docRef, data, {merge: true});
}

async function deletePartner(docId) {
    const docRef = doc(db, partnerPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", partnerPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function queryPartner(field, comparision, value) {
    const ref = collection(db, partnerPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function getTags() {
    const docRef = collection(db, tagsPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps.docs;
}

async function addSession(subject, topic, subTopic, timestamp, duration, prerequisites, type, details) {
    const docRef = collection(db, sessionPath);

    const data = {
        subject: subject,
        topic: topic,
        subTopic: subTopic,
        timestamp: timestamp,
        duration: duration,
        prerequisites: prerequisites,
        type: type,
        details: details
    }

    await addDoc(docRef, data);
}

async function getSessions() {
    const docRef = collection(db, sessionPath);
    const docSnaps = await getDocs(docRef);
    return docSnaps;
}

async function getSession(sessionId) {
    const docRef = doc(db, sessionPath, sessionId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}

async function updateSession(subject, topic, subTopic, timestamp, duration, prerequisites, type, details, sessionId) {
    const docRef = doc(db, sessionPath, sessionId);

    const data = {
        subject: subject,
        topic: topic,
        subTopic: subTopic,
        timestamp: timestamp,
        duration: duration,
        prerequisites: prerequisites,
        type: type,
        details: details
    }

    await setDoc(docRef, data, {merge: true});
}

async function updateStudentSession(subject, topic, subTopic, timestamp, duration, prerequisites, type, details, sessionId) {
    const docRef = doc(db, sessionPath, sessionId);

    const data = {
        subject: subject,
        topic: topic,
        subTopic: subTopic,
        timestamp: timestamp,
        duration: duration,
        prerequisites: prerequisites,
        type: type,
        details: details,
    }

    await setDoc(docRef, data, {merge: true});
}

async function deleteSession(docId) {
    const docRef = doc(db, sessionPath, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", sessionPath, docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function querySession(field, comparision, value) {
    const ref = collection(db, sessionPath);
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}

async function createSlot(schoolId, slotNumber, month, slotData, allotedSlots) {
    const schoolDoc = doc(db, "schoolData", schoolId);
    const docRef = collection(db, "schoolData", schoolId, "slotManagement");
    console.log(docRef);


    const data = {
        slotNumber: parseInt(slotNumber),
        month: month,
        slot: slotData,
        allotedSlots: allotedSlots
    }

    const slot = await addDoc(docRef, data);

    await setDoc(schoolDoc, {
        slotManagement: slot
    }, {merge: true});
}

async function updateSlot(slotRef, slotNumber, month, slotData, allotedSlots) {
    const schoolDoc = slotRef;

    const data = {
        slotNumber: parseInt(slotNumber),
        month: month,
        slot: slotData,
        allotedSlots: allotedSlots
    }

    await updateDoc(schoolDoc, data);
}

async function deleteSlot(schoolId, slotId) {
    const schoolDoc = doc("schoolData", schoolId);
    const slotDoc = doc("schoolData", schoolId, "slotManagement", slotId);

    await deleteDoc(slotDoc);

    await setDoc(schoolDoc, {
        slotManagement: ""
    }, {merge: true});
}

async function getSlot(field, comparision, value) {
    const ref = collection(db, "schoolData");
    const q = await query(ref, where(field, comparision, value));
    const querySnapshot = await getDocs(q);
    const slotDoc = querySnapshot.docs[0].data().slotManagement;
    return slotDoc;
}

async function deleteAssignedTA(docId, taskId) {
    const docRef = doc(db, studentPath, docId, "taData", taskId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", studentPath, docId, "taData", taskId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function deleteAssignedCompetition(docId, competitionId) {
    const docRef = doc(db, studentPath, docId, "competitionData", competitionId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", studentPath, docId, "competitionData", competitionId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function deleteAssignedCourse(docId, courseId) {
    const docRef = doc(db, studentPath, docId, "coursesData", courseId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", studentPath, docId, "courseData", courseId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function addSubject(subName) {
    const subjectRef = collection(db, subjectPath);
    await addDoc(subjectRef, { name: subName });
  }

  async function getSubjects() {
    const subjectRef = collection(db, subjectPath);
    const snapshot = await getDocs(subjectRef);
    return snapshot.docs;
  }

// async function deleteSubject(docId) {
//     console.log(docId);
//     const docRef = doc(db, subjectPath, docId);
//     const snap = await getDoc(docRef);
//     const archiveRef = doc(db, "archivedData", "appData", subjectPath, docId);
//     await setDoc(archiveRef, snap.data());
//     await deleteDoc(docRef);
// }

async function deleteSubject(docId) {
    const docRef = doc(db, "subject", docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", "subject", docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
  }
  

async function addTopic(name, subjectId) {
    const docRef = collection(db, `subject/${subjectId}/topic`);
    await addDoc(docRef, {
        name: name
    });
}

async function getTopics(subjectId) {
    const id = `/subject/${subjectId}/topic`;
    const docRef = collection(db, id);
    const docSnaps = await getDocs(docRef);
    return docSnaps.docs;
}

async function deleteTopic(docId, subjectId) {
    console.log(docId);
    const docRef = doc(db, `subject/${subjectId}/topic`, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", "topic", docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function addSubTopic(name, subjectId, topicId) {
    const docRef = collection(db, `subject/${subjectId}/topic/${topicId}/subTopic`);
    await addDoc(docRef, {
        name: name
    });
}

async function getSubtopics(subjectId, topicId) {
    const docRef = collection(db, `subject/${subjectId}/topic/${topicId}/subTopic`);
    const docSnaps = await getDocs(docRef);
    return docSnaps.docs;
}

async function deleteSubtopic(docId, subjectId, topicId) {
    const docRef = doc(db, `subject/${subjectId}/topic/${topicId}/subTopic`, docId);
    const snap = await getDoc(docRef);
    const archiveRef = doc(db, "archivedData", "appData", "subTopic", docId);
    await setDoc(archiveRef, snap.data());
    await deleteDoc(docRef);
}

async function getStudentLearningPathway(studentId) {
    const pathwayRef = doc(db, studentPath, studentId, "learningPathway", "current");
    const snap = await getDoc(pathwayRef);
    if (!snap.exists()) {
        return null;
    }
    return snap.data();
}

async function setStudentLearningPathway(studentId, pathwayData) {
    const pathwayRef = doc(db, studentPath, studentId, "learningPathway", "current");
    await setDoc(pathwayRef, pathwayData, { merge: true });
    return pathwayRef;
}

async function assignPathwayActivityToStudent(studentId, activityData, courseMeta, options = {}) {
    const studentTARef = doc(db, "studentData", studentId, "taData", activityData.taID);
    const globalTARef = doc(db, "taData", activityData.taID);
    const approved = options?.approved !== undefined ? options.approved : false;

    const assignmentPayload = {
        ...activityData,
        approved,
        pathwayAssigned: true,
        assignedAt: new Date().toISOString(),
        pathwayMeta: {
            courseOrder: courseMeta.courseOrder,
            courseTitle: courseMeta.title,
            activityOrder: activityData.pathwayActivityOrder,
        }
    };

    await setDoc(studentTARef, assignmentPayload, { merge: true });
    await setDoc(globalTARef, assignmentPayload, { merge: true });

    const studentRef = doc(db, "studentData", studentId);
    await setDoc(studentRef, { currentCourse: studentTARef }, { merge: true });

    return studentTARef;
}

async function assignPathwayCourseToStudent(studentId, courseData, courseOrder = 0) {
    const d = new Date();
    const currentDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    const pathwayCourseId = courseData?.pathwayCourseId || `LP-${studentId}-${courseOrder + 1}`;

    const studentCourseRef = doc(db, "studentData", studentId, "coursesData", pathwayCourseId);
    const globalCourseRef = doc(db, "coursesData", pathwayCourseId);

    const payload = {
        courseName: courseData?.title || `Pathway Course ${courseOrder + 1}`,
        courseTag: Array.isArray(courseData?.targetSkills) && courseData.targetSkills.length > 0 ? courseData.targetSkills : ["Personalized", "AI Generated"],
        description: courseData?.description || "AI generated personalized course from learning pathway.",
        organizedBy: "AI Personalized Pathway",
        applicationStartDate: "",
        applicationEndDate: "",
        crsStartDate: "",
        crsEndDate: "",
        classesFrom: "",
        classesTo: "",
        refLink: "",
        requirements: Array.isArray(courseData?.targetSkills) ? courseData.targetSkills : [],
        comments: "Generated for personalized learning pathway",
        approved: false,
        assignedAt: new Date().toISOString(),
        status: [{ status: "Assigned", modifiedAt: currentDate }],
        pathwayMeta: {
            source: "learningPathway",
            courseOrder,
        }
    };

    await setDoc(studentCourseRef, payload, { merge: true });
    await setDoc(globalCourseRef, payload, { merge: true });

    return studentCourseRef;
}

function isCompletedStatus(status) {
    if (!status || !Array.isArray(status) || status.length === 0) {
        return false;
    }

    const lastStatus = status[status.length - 1]?.status || "";
    const normalized = lastStatus.toLowerCase();

    return normalized.includes("completed") || normalized.includes("review completed") || normalized.includes("ta completed");
}

async function syncLearningPathwayProgressFromStudent(studentId, options = {}) {
    const disableAutoAssign = options?.disableAutoAssign === true;
    const pathwayRef = doc(db, "studentData", studentId, "learningPathway", "current");
    const pathwaySnap = await getDoc(pathwayRef);
    if (!pathwaySnap.exists()) {
        return null;
    }

    const pathway = pathwaySnap.data();
    if (!Array.isArray(pathway.courses) || pathway.courses.length === 0) {
        return pathway;
    }

    const studentTAsSnap = await getDocs(collection(db, "studentData", studentId, "taData"));
    const assignedMap = new Map();
    const completedMap = new Map();
    const mentorNeededMap = new Map();

    studentTAsSnap.forEach((taDoc) => {
        const taData = taDoc.data();
        assignedMap.set(taDoc.id, true);
        completedMap.set(taDoc.id, isCompletedStatus(taData.status));
        const statusArr = Array.isArray(taData.status) ? taData.status : [];
        const lastStatus = (statusArr[statusArr.length - 1]?.status || "").toLowerCase();
        mentorNeededMap.set(taDoc.id, lastStatus.includes("mentor needed"));
    });

    let currentCourseIndex = pathway.currentCourseIndex || 0;

    const nextCourses = pathway.courses.map((course, courseIndex) => {
        const activities = Array.isArray(course.activities) ? course.activities : [];

        let completedActivities = 0;
        let currentActivityIndex = course.currentActivityIndex || 0;
        let nextUnassignedActivity = null;

        const nextActivities = activities.map((activity, activityIndex) => {
            const assigned = assignedMap.has(activity.taID);
            const completed = completedMap.get(activity.taID) === true;

            if (completed && (course.source !== "manual" || !activity.parentTaId)) {
                completedActivities += 1;
            }

            if (assigned && !completed && activityIndex >= currentActivityIndex) {
                currentActivityIndex = activityIndex;
            }

            if (!nextUnassignedActivity && !assigned) {
                nextUnassignedActivity = { ...activity, pathwayActivityOrder: activityIndex };
            }

            return {
                ...activity,
                pathwayAssigned: assigned,
                pathwayCompleted: completed,
                pathwayMentorNeeded: mentorNeededMap.get(activity.taID) === true,
            };
        });

        let status = "upcoming";
        if (completedActivities >= (course.requiredActivities || activities.length || 0) && activities.length > 0) {
            status = "completed";
        } else if (courseIndex < currentCourseIndex) {
            status = "completed";
        } else if (courseIndex === currentCourseIndex) {
            status = "ongoing";
        }

        return {
            ...course,
            activities: nextActivities,
            completedActivities,
            requiredActivities: course.requiredActivities || activities.length,
            currentActivityIndex,
            status,
            _nextUnassignedActivity: courseIndex === currentCourseIndex && status !== "completed" ? nextUnassignedActivity : null,
        };
    });

    while (currentCourseIndex < nextCourses.length && nextCourses[currentCourseIndex].status === "completed") {
        currentCourseIndex += 1;
    }

    const normalizedCurrentCourseIndex = Math.min(currentCourseIndex, Math.max(nextCourses.length - 1, 0));

    if (normalizedCurrentCourseIndex < nextCourses.length) {
        for (let i = 0; i < nextCourses.length; i++) {
            if (nextCourses[i].status !== "completed") {
                nextCourses[i].status = i === normalizedCurrentCourseIndex ? "ongoing" : "upcoming";
            }
        }
    }

    const completedCourses = nextCourses.filter((course) => course.status === "completed").length;
    const overallProgress = nextCourses.length > 0 ? Math.round((completedCourses / nextCourses.length) * 100) : 0;
    const pathwayStatus = completedCourses === nextCourses.length && nextCourses.length > 0 ? "completed" : "active";

    const nextPathway = {
        ...pathway,
        courses: nextCourses.map((course) => {
            const { _nextUnassignedActivity, ...rest } = course;
            return rest;
        }),
        currentCourseIndex: normalizedCurrentCourseIndex,
        overallProgress,
        status: pathwayStatus,
        updatedAt: new Date().toISOString(),
    };

    await setDoc(pathwayRef, nextPathway, { merge: true });

    if (!disableAutoAssign && pathwayStatus !== "completed") {
        const activeCourseForAssignment = nextCourses[normalizedCurrentCourseIndex];
        if (activeCourseForAssignment) {
            await assignPathwayCourseToStudent(studentId, activeCourseForAssignment, normalizedCurrentCourseIndex);
        }
    }

    if (!disableAutoAssign && pathwayStatus !== "completed") {
        const activeCourse = nextCourses[normalizedCurrentCourseIndex];
        if (activeCourse?._nextUnassignedActivity) {
            await assignPathwayActivityToStudent(studentId, activeCourse._nextUnassignedActivity, {
                courseOrder: normalizedCurrentCourseIndex,
                title: activeCourse.title,
            }, {
                approved: false,
            });

            const updatedCourses = [...nextPathway.courses];
            const targetCourse = { ...updatedCourses[normalizedCurrentCourseIndex] };
            const updatedActivities = targetCourse.activities.map((activity) => {
                if (activity.taID === activeCourse._nextUnassignedActivity.taID) {
                    return { ...activity, pathwayAssigned: true };
                }
                return activity;
            });
            targetCourse.activities = updatedActivities;
            updatedCourses[normalizedCurrentCourseIndex] = targetCourse;

            const withAssignedActivity = {
                ...nextPathway,
                courses: updatedCourses,
            };
            await setDoc(pathwayRef, withAssignedActivity, { merge: true });
            return withAssignedActivity;
        }
    }

    return nextPathway;
}

async function assignManualActivityToStudent(studentId, activityData, courseMeta, options = {}) {
    // Fetch full TA content from global taData so goals, materials, instructions etc. are included
    let fullTA = {};
    try {
        const globalSnap = await getDoc(doc(db, activityPath, activityData.taID));
        if (globalSnap.exists()) fullTA = globalSnap.data();
    } catch (e) {
        console.error("Could not fetch full TA data:", e);
    }

    // TAs from the kitty are pre-approved; AI-generated remedial TAs go to unapproved
    const approved = options.approved !== undefined ? options.approved : true;

    const studentTARef = doc(db, "studentData", studentId, "taData", activityData.taID);
    const payload = {
        ...fullTA,        // full content: goals, materials, instructions, tips, assessment, extensions, resources
        ...activityData,  // pathway-specific overrides (taID, taName, intro, parentTaId, etc.)
        approved,
        pathwayAssigned: true,
        assignedAt: new Date().toISOString(),
        pathwayMeta: {
            courseOrder: courseMeta.courseOrder,
            courseTitle: courseMeta.title,
            activityOrder: activityData.pathwayActivityOrder || 0,
            source: "manual",
        },
    };
    await setDoc(studentTARef, payload, { merge: true });
    const studentRef = doc(db, "studentData", studentId);
    await setDoc(studentRef, { currentCourse: studentTARef }, { merge: true });
    return studentTARef;
}

async function assignManualSkillMission(studentId, course, existingPathway) {
    const d = new Date();
    const currentDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    const courseTAs = Array.isArray(course.courseTAs) ? course.courseTAs : [];

    const assignedAt = new Date().toISOString();
    const activities = courseTAs.map((ta, idx) => ({
        ...ta,
        pathwayAssigned: false,
        pathwayCompleted: false,
        sentimentChecked: false,
        pathwayActivityOrder: idx,
        assignedAt,
        status: [{ status: "Assigned", modifiedAt: currentDate }],
        comments: "",
    }));

    const rootCount = activities.filter(a => !a.parentTaId).length;
    const existingCourses = Array.isArray(existingPathway?.courses) ? existingPathway.courses : [];
    const courseOrder = existingCourses.length;

    const newCourse = {
        title: course.courseName,
        description: course.description || "",
        targetSkills: Array.isArray(course.courseTag) ? course.courseTag : [],
        source: "manual",
        courseId: course.docId,
        status: "ongoing",
        activities,
        requiredActivities: rootCount,
        completedActivities: 0,
        currentActivityIndex: 0,
        courseOrder,
    };

    const basePathway = existingPathway || {
        pathwayTitle: "Learning Pathway",
        pathwaySummary: "Manually assigned skill missions",
        status: "active",
        overallProgress: 0,
        currentCourseIndex: courseOrder,
        createdAt: new Date().toISOString(),
    };

    let updatedPathway = {
        ...basePathway,
        courses: [...existingCourses, newCourse],
        updatedAt: new Date().toISOString(),
    };

    await setStudentLearningPathway(studentId, updatedPathway);

    // Immediately assign the first root TA to the student
    const firstRoot = activities.find(a => !a.parentTaId);
    if (firstRoot) {
        await assignManualActivityToStudent(studentId, firstRoot, { courseOrder, title: newCourse.title });

        const assignedActivities = activities.map(a =>
            a.taID === firstRoot.taID ? { ...a, pathwayAssigned: true } : a
        );
        const finalCourses = [...existingCourses, { ...newCourse, activities: assignedActivities }];
        updatedPathway = { ...updatedPathway, courses: finalCourses };
        await setStudentLearningPathway(studentId, updatedPathway);
    }

    return updatedPathway;
}

export default db;
export { db };
export { deleteGeneratedActivity };
export { addStudent, getStudents, getStudent, updateStudent, deleteStudent, queryStudent, deleteAssignedTA };
export { addMentor, getMentors, getMentor, updateMentor, deleteMentor, queryMentor };
export { addSchool, getSchools, getSchool, updateSchool, deleteSchool, querySchool };
export { addApartment, getApartments, getApartment, updateApartment, deleteApartment, queryApartment };
export { addTeam, getTeams, getTeam, updateTeam, deleteTeam, queryTeam };
export { addActivity, getActivities, getActivity, updateActivity, deleteActivity, queryActivity, updateTActivity };
export { addCompetition, getCompetitions, getCompetition, updateCompetition, deleteCompetition, queryCompetition, deleteAssignedCompetition, updateStudentCompetition };
export { addCourse, getCourses, getCourse, updateCourse, deleteCourse, queryCourse, deleteAssignedCourse, updateStudentCourse };
export { getTags }
export { addProject, getProjects, getProject, updateProject, deleteProject, queryProject };
export { addPartner, getPartners, getPartner, updatePartner, deletePartner, queryPartner };
export { addSession, getSessions, getSession, updateSession, updateStudentSession, deleteSession, querySession };
export { createSlot, updateSlot, deleteSlot, getSlot };
export { task, taskAssign, deleteTask, getTasksById };
export { addSubject, getSubjects, deleteSubject, addTopic, getTopics, deleteTopic, addSubTopic, getSubtopics, deleteSubtopic};
export { getStudentLearningPathway, setStudentLearningPathway, assignPathwayActivityToStudent, assignPathwayCourseToStudent, syncLearningPathwayProgressFromStudent, assignManualActivityToStudent, assignManualSkillMission };